import { Connection } from '@solana/web3.js';
import { ethers } from 'ethers';

const getRpcProviders = (configurations) => {
    const rpcProviders = {};
    if (configurations === null || configurations === void 0 ? void 0 : configurations.evm) {
        rpcProviders.evm = configurations.evm.map((network) => {
            var _a;
            const rpcUrl = ((_a = network.privateCustomerRpcUrls) === null || _a === void 0 ? void 0 : _a[0]) || network.rpcUrls[0];
            const provider = new ethers.providers.JsonRpcProvider(rpcUrl, network.chainId);
            return {
                chainId: network.chainId,
                chainName: network.chainName,
                provider,
            };
        });
    }
    if (configurations === null || configurations === void 0 ? void 0 : configurations.solana) {
        rpcProviders.solana = configurations.solana.map((network) => {
            var _a;
            const rpcUrl = ((_a = network.privateCustomerRpcUrls) === null || _a === void 0 ? void 0 : _a[0]) || network.rpcUrls[0];
            const provider = new Connection(rpcUrl);
            return {
                chainId: parseInt(network.chainId),
                chainName: network.name,
                provider,
            };
        });
    }
    if (Object.keys(rpcProviders).length === 0) {
        return undefined;
    }
    return rpcProviders;
};
const getEvmDefaultRpcProvider = (configurations) => {
    const rpcProviders = getRpcProviders(configurations);
    if (!rpcProviders) {
        return undefined;
    }
    if (!rpcProviders.evm) {
        return undefined;
    }
    const defaultProvider = rpcProviders.evm.find((provider) => provider.chainId === 1);
    return defaultProvider;
};
const getSolanaDefaultRpcProvider = (configurations) => {
    const rpcProviders = getRpcProviders(configurations);
    if (!rpcProviders) {
        return undefined;
    }
    if (!rpcProviders.solana) {
        return undefined;
    }
    const defaultProvider = rpcProviders.solana.find((provider) => provider.chainId === 101);
    return defaultProvider;
};
const getEvmRpcProviderByChainId = (configurations, chainId) => {
    const rpcProviders = getRpcProviders(configurations);
    if (!rpcProviders) {
        return undefined;
    }
    if (rpcProviders.evm) {
        const evmRpcProvider = rpcProviders.evm.find((rpcProvider) => rpcProvider.chainId === chainId);
        return evmRpcProvider;
    }
    return undefined;
};

export { getEvmDefaultRpcProvider, getEvmRpcProviderByChainId, getRpcProviders, getSolanaDefaultRpcProvider };
